import { YoloBotCSS } from './YoloBotCSS.styled'
import { useYoloBotRegister } from './useYoloBotRegister'

export const YoloBot = ({ showRegisterModal }) => {
  useYoloBotRegister(showRegisterModal)
  return (
    <YoloBotCSS id='body'>
      <div id='page_wrapper'>
        <div id='main'>
          <div className='content'>
            <div className='project_description'>
              A high-performance leveraged bidding bot by <strong>YOLOREKT</strong>
            </div>
            <div className='yolobot_logo'></div>
            <div className='project_tagline'>Place lightning-fast 1000x leveraged bids from Telegram</div>
            <form>
              <a id='bot-button' href='https://t.me/yolorektbot' type='button' target='blank' rel='noopener noreferrer'>
                Bid now on <strong>Telegram</strong>
              </a>
            </form>
            <div className='view_docs'>
              <a href='https://docs.yolorekt.finance/docs/yolobot/quick-start-and-tutorial-guide' target='blank'>
                Get started with our quick-start and tutorial guide
              </a>
            </div>

            <footer>
              <a href='https://yolorekt.finance' target='blank' className='yolorekt_logo-stacked'>
                {' '}
              </a>

              <div id='landing-details'>
                <div id='priv-terms'>
                  <a href='https://docs.yolorekt.finance/docs/legal/privacy-policy' target='blank'>
                    Privacy Policy
                  </a>
                  &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                  <a href='https://docs.yolorekt.finance/docs/legal/terms-of-service' target='blank'>
                    Terms of Service
                  </a>
                  &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                  <a href='https://docs.yolorekt.finance' target='blank'>
                    Docs
                  </a>
                </div>

                <div id='copyright'>
                  <strong>
                    &copy; Copyright
                    <script type='text/javascript'>var year = new Date();document.write(year.getFullYear());</script>
                  </strong>
                  All rights reserved
                </div>
              </div>

              <div className='about'>
                YOLOREKT designs, builds, and provides advanced next-degen leveraged gaming experiences that offer
                killer incentives, royalties, and leverage up-to 1000x with no minimum portfolio balance.
                <div>
                  Visit and play YOLOREKT @{' '}
                  <a href='https://yolorekt.finance' target='blank'>
                    https://yolorekt.finance
                  </a>
                </div>
              </div>

              <div id='landing-social'>
                <a
                  href='https://twitter.com/playyolorekt'
                  target='blank'
                  rel='noopener noreferrer'
                  className='icon twitter'
                >
                  {' '}
                </a>
                <a
                  href='https://vm.tiktok.com/ZTdmEw6xk/'
                  target='blank'
                  rel='noopener noreferrer'
                  className='icon tiktok'
                >
                  {' '}
                </a>
                <a href='https://medium.com/yolorekt' target='blank' rel='noopener noreferrer' className='icon medium'>
                  {' '}
                </a>
                <a
                  href='https://t.me/joinchat/NBBv1hQmV26flFM_5MD4_w'
                  target='blank'
                  rel='noopener noreferrer'
                  className='icon telegram'
                >
                  {' '}
                </a>
                <a href='https://discord.gg/yolorekt' target='blank' rel='noopener noreferrer' className='icon discord'>
                  {' '}
                </a>
                <a
                  href='mailto:support@yolorekt.com?Subject=Hello%20again'
                  target='blank'
                  rel='noopener noreferrer'
                  className='icon email'
                >
                  {' '}
                </a>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </YoloBotCSS>
  )
}
